/* istanbul ignore file */
export { default } from './ContactForm';
